import type { Category, Item, Station } from "../../../../api/menu";

// Цветовете, с които „Маркиране" оцветява продукти/редове по настройката
// `colorBy` (настройка на ресторанта, Конфигурация → Маркиране): по СТАНЦИЯ — `station.color`;
// по ГРУПА — собственият `category.color`, а ако липсва — цветът на ПРЕКИЯ
// родител (само едно ниво нагоре). Няма измислен цвят: и родителят без цвят
// → null → неутралната кутийка с бордър.

export type ColorBy = "group" | "station" | "none";

const FALLBACK_STATION_COLOR = "#C97C2C"; // pos-accent

export function stationColorOf(station: Station | undefined): string | null {
  if (!station) return null;
  return station.color || FALLBACK_STATION_COLOR;
}

/** Цвят на група: собственият `color` от базата, иначе този на ПРЕКИЯ
 *  родител (само едно ниво, не по цялата верига); без измислен цвят
 *  (и родителят без цвят → null → неутрална). */
export function buildGroupColorLookup(categories: Category[]) {
  const byId = new Map(categories.map((cat) => [cat.id, cat]));
  return (categoryId: number | null): string | null => {
    const cat = categoryId === null ? undefined : byId.get(categoryId);
    if (!cat) return null;
    if (cat.color) return cat.color;
    const parent = cat.parentId === null ? undefined : byId.get(cat.parentId);
    return parent?.color ?? null;
  };
}

/** Цветът на продукт според настройката: станция → първата му станция. */
export function itemColor(
  item: Item,
  colorBy: ColorBy,
  stationsById: Map<number, Station>,
  groupColor: (categoryId: number | null) => string | null,
): string | null {
  if (colorBy === "none") return null;
  if (colorBy === "station") {
    return stationColorOf(stationsById.get(item.stationIds[0]));
  }
  return groupColor(item.categoryId);
}

/** Лек фон в цвета (данни от базата → inline style е позволен):
 *  смесване с картата, за да остане текстът четим и в тъмна тема. */
export function tintBackground(
  color: string | null,
  strength = 18,
): string | undefined {
  if (!color) return undefined;
  return `color-mix(in srgb, ${color} ${strength}%, var(--color-pos-card))`;
}
